"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagEditState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_state_1 = require("../components/input/input.state");
class TagEditState {
    constructor(text) {
        this.input = new input_state_1.InputState(text);
    }
    setTagId(tagId) {
        this.tagId = tagId;
    }
    setRenaming(tagId) {
        this.renamingTagId = tagId;
    }
    cancelRenaming() {
        this.setRenaming(undefined);
    }
    editTag(tagId, value) {
        this.setTagId(tagId);
        this.input.setValue(value);
    }
    isEditingTag(tagId) {
        if (tagId == null) {
            return this.input.value != null;
        }
        return this.input.value != null && this.tagId === tagId;
    }
    isRenamingTag(tagId) {
        if (tagId == null) {
            return this.renamingTagId != null;
        }
        return this.renamingTagId === tagId;
    }
}
exports.TagEditState = TagEditState;
tslib_1.__decorate([
    mobx_1.observable
], TagEditState.prototype, "tagId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TagEditState.prototype, "renamingTagId", void 0);
tslib_1.__decorate([
    mobx_1.action
], TagEditState.prototype, "setTagId", null);
tslib_1.__decorate([
    mobx_1.action
], TagEditState.prototype, "setRenaming", null);
tslib_1.__decorate([
    mobx_1.action
], TagEditState.prototype, "cancelRenaming", null);
tslib_1.__decorate([
    mobx_1.action
], TagEditState.prototype, "editTag", null);
//# sourceMappingURL=tag.edit.state.js.map